// Single source of truth for user-visible brand identity on the marketing
// site. The repo/service names stay as-is elsewhere -- only this file (and
// the main app's client/src/brand.js + BRAND_NAME/BRAND_DOMAIN/
// BRAND_SUPPORT_EMAIL settings in foursite/settings/common.py) drive what
// visitors actually see, so a future rebrand means changing these places
// instead of grepping the whole codebase again.

export { default as Logo } from "./assets/Logo";

export const BRAND_NAME = "4-ward.ai";
export const BRAND_DOMAIN = "4-ward.ai";
export const BRAND_SUPPORT_EMAIL = "info@4-ward.ai";
export const APP_URL = "https://app.4-ward.ai";
